import LayoutV2 from 'components/common/LayoutV2';
import CommunityProfileV2 from 'components/community/profileV2/CommunityProfile';
import { IsMobileContext } from 'contexts/IsMobile';
import { fetchCommunityProfile } from 'lib/api/community_api';
import { GetStaticProps } from 'next';
import { useContext, useState } from 'react';
import { CommunityUserProfile } from 'types/community';

type Props = {
  profile: CommunityUserProfile;
};

export default function CommunityProfilePage({ profile }: Props) {
  const { isMobile } = useContext(IsMobileContext);
  const [showProfileBanner, setShowProfileBanner] = useState<boolean>(false);

  function onProfileVisibleChange(isVisible: boolean) {
    setShowProfileBanner(!isVisible);
  }

  return (
    <LayoutV2
      title={profile.username}
      navTitle={'Marketplace'}
      showProfileBanner={!isMobile && showProfileBanner}
      profile={profile}
    >
      <CommunityProfileV2
        profile={profile}
        onProfileVisibleChange={onProfileVisibleChange}
      />
    </LayoutV2>
  );
}

export async function getStaticPaths() {
  return { paths: [], fallback: 'blocking' };
}

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  const username = (params?.username as string).replace(/^@/, '');
  const profile = await fetchCommunityProfile(username);
  if (profile === undefined || profile === null) {
    return { notFound: true };
  }

  return {
    props: {
      profile,
    },
    revalidate: 1,
  };
};
